export const PanelSettingsGroupsEditAccountsMessages = {
    GetAccountsFailed: {
        key: 'GetAccountsFailed',
        message: 'Error while communication with the server. Unable to get detailed information about group\'s accounts.'
    }
};
